import React from "react";
import { useHistory } from "react-router-dom";

export default function SoulCookiesNav() {
  const history = useHistory();

  const games = [
    {
      nameZh: "記憶配對",
      nameId: "Memory",
      icon: "/games/memory.svg",
      path: "/g/memory",
    },
    {
      nameZh: "文字謎題",
      nameId: "Puzzle",
      icon: "/games/puzzle.svg",
      path: "/g/puzzle",
    },
    {
      nameZh: "抄經本",
      nameId: "Salinan Sutra",
      icon: "/games/writing.svg",
      path: "/g/writing",
    },
  ];

  const styles = {
    page: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #fff7f0, #fdfcff)",
      padding: "1.5rem",
      fontFamily: "sans-serif",
    },

    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "2rem",
    },

    backBtn: {
      fontSize: "1rem",
      padding: "0.4rem 0.8rem",
      borderRadius: "0.8rem",
      border: "none",
      background: "#f1f1f1",
      cursor: "pointer",
    },

    titleWrap: {
      textAlign: "center",
      flex: 1,
    },

    titleZh: {
      fontSize: "1.6rem",
      fontWeight: "600",
    },

    titleEn: {
      fontSize: "1rem",
      opacity: 0.6,
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(8rem, 1fr))",
      gap: "1.2rem",
    },

    card: {
      background: "#ffffff",
      borderRadius: "1.4rem",
      padding: "1.2rem",
      textAlign: "center",
      cursor: "pointer",
      boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
      transition: "0.2s",
    },

    icon: {
      width: "3.5rem",
      height: "3.5rem",
      marginBottom: "0.6rem",
    },

    nameZh: {
      fontSize: "1.1rem",
      fontWeight: "600",
    },

    nameId: {
      fontSize: "0.9rem",
      opacity: 0.6,
    },

    footer: {
      marginTop: "2.5rem",
      textAlign: "center",
      fontSize: "0.8rem",
      opacity: 0.5,
    },

    disclaimer: {
      marginTop: "2rem",
      padding: "1rem 1.2rem",
      borderRadius: "1rem",
      background: "linear-gradient(135deg, #fff3cd, #ffe8cc)",
      textAlign: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    },

    disclaimerZh: {
      fontSize: "0.95rem",
      fontWeight: "500",
      marginBottom: "0.3rem",
    },

    disclaimerId: {
      fontSize: "0.85rem",
      opacity: 0.7,
    },

  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <button
          className="btn-icon back-btn"
          onClick={() => history.push("/")}
          aria-label="Back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
            <path fillRule="evenodd" d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z" clipRule="evenodd" />
          </svg>
        </button>
        
        <div style={styles.titleWrap}>
          <div style={styles.titleZh}>小點心</div>
          <div style={styles.titleEn}>Soul Cookies</div>
        </div>
      </div>

      {/* GRID */}
      <div style={styles.grid}>
        {games.map((g, i) => (
          <div
            key={i}
            style={styles.card}
            onClick={() => history.push(g.path)}
          >
            <img src={g.icon} alt="" style={styles.icon} />

            <div style={styles.nameZh}>{g.nameZh}</div>
            <div style={styles.nameId}>{g.nameId}</div>
          </div>
        ))}
      </div>

      <div style={styles.disclaimer}>
        <div style={styles.disclaimerZh}>
          請善用時間，在課程或活動中專心投入。
        </div>
        <div style={styles.disclaimerId}>
          Gunakan waktu dengan bijak, tetap fokus saat kelas/kegiatan.
        </div>
      </div>

      {/* FOOTER */}
      <div style={styles.footer}>
        2026 | lienfoyuan.com
      </div>
    </div>
  );
}